<app-page-header>
  <div class="users-page-header">
    <div class="users-page-header__content">
      <!-- <div class="users-page-header__icon">
        <i class="pi pi-users"></i>
      </div> -->

      <div>
        <h3 class="page-title">Manage Users</h3>
        <!-- <p class="page-subtitle">
          Create, manage and maintain user accounts
        </p> -->
      </div>
    </div>
  </div>
</app-page-header>

<section class="user-section">
  <div class="container-fluid">

    <!-- =====================================================
         PAGE TOOLBAR
    ====================================================== -->
    <div class="users-toolbar">

      <div class="users-toolbar__left">
        <div class="user-summary">
          <div class="user-summary__icon">
            <i class="pi pi-users"></i>
          </div>

          <div>
            <span class="user-summary__label">Total Users</span>
            <strong class="user-summary__value">
              {{ totalRowCount }}
            </strong>
          </div>
        </div>
      </div>

      <div class="users-toolbar__right">

        <!-- Search -->
        <div class="search-box">
          <i class="pi pi-search"></i>

          <input
            type="text"
            [(ngModel)]="search"
            (keyup)="searchInList.next($event)"
            placeholder="Search users..."
            autocomplete="off"
          />

          @if (search) {
            <button
              type="button"
              class="search-clear"
              (click)="search = ''; searchInList.next($event)"
            >
              <i class="pi pi-times"></i>
            </button>
          }
        </div>

        <!-- Create -->
        <button
          type="button"
          class="action-btn action-btn--primary"
          (click)="createNew()"
        >
          <i class="pi pi-plus"></i>
          <span>Create User</span>
        </button>

        <!-- OTP -->
        <button
          type="button"
          class="action-btn action-btn--secondary"
          (click)="sendMailtoUser(listOfUsers)"
        >
          <i class="pi pi-envelope"></i>
          <span>Re-send OTP</span>
        </button>

        <!-- Bulk -->
        <button
          type="button"
          class="action-btn action-btn--success"
          (click)="open = true"
        >
          <i class="pi pi-cloud-upload"></i>
          <span>Bulk Upload</span>
        </button>

      </div>
    </div>


    <!-- =====================================================
         USERS TABLE CARD
    ====================================================== -->
    <div class="users-card">

      <!-- Table Header -->
      <div class="users-card__header">
        <div>
          <h4>User Accounts</h4>
          <p>View and manage all registered users.</p>
        </div>

        <div class="record-badge">
          <i class="pi pi-list"></i>
          {{ totalRowCount }} Records
        </div>
      </div>


      <!-- Responsive Table -->
      <div class="table-responsive">

        <table class="user-table">

          <thead>
            <tr>
              <th class="col-user">User</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Role</th>
              <th>Status</th>
              <th class="col-action">Actions</th>
            </tr>
          </thead>

          <tbody>

            @if (listOfUsers.length === 0) {

              <tr>
                <td colspan="6">

                  <div class="empty-state">

                    <div class="empty-state__icon">
                      <i class="pi pi-users"></i>
                    </div>

                    <h4>No users found</h4>

                    <p>
                      No user records match your current search.
                    </p>

                    @if (search) {
                      <button
                        type="button"
                        class="empty-state__button"
                        (click)="search = ''"
                      >
                        Clear Search
                      </button>
                    }

                  </div>

                </td>
              </tr>

            } @else {

              @for (
                user of listOfUsers
                  | paginate : {
                      itemsPerPage: RECORD_LIMIT,
                      currentPage: page,
                      totalItems: totalRowCount
                    };
                track user;
                let i = $index
              ) {

                <tr>

                  <!-- User -->
                  <td class="user-cell">

                    <div class="user-profile">

                      <div class="user-avatar">

                        @if (user.user_icon) {

                          <img
                            [src]="profileUrl + user.user_icon"
                            alt="User"
                          />

                        } @else {

                          <span>
                            {{
                              user.first_name?.charAt(0)?.toUpperCase()
                            }}
                            {{
                              user.last_name?.charAt(0)?.toUpperCase()
                            }}
                          </span>

                        }

                      </div>

                      <div class="user-info">

                        <strong>
                          {{ user.first_name }} {{ user.last_name }}
                        </strong>

                        <!-- <span>
                          User ID #{{ user.user_id || i + 1 }}
                        </span> -->

                      </div>

                    </div>

                  </td>


                  <!-- Email -->
                  <td>
                    <div class="table-value">
                      <i class="pi pi-envelope"></i>
                      <span>{{ user.email_id }}</span>
                    </div>
                  </td>


                  <!-- Phone -->
                  <td>
                    <div class="table-value">
                      <i class="pi pi-phone"></i>
                      <span>{{ user.phone_no || '—' }}</span>
                    </div>
                  </td>


                  <!-- Role -->
                  <td>

                    <span class="role-badge">
                      <i class="pi pi-shield"></i>
                      {{ user.role_name }}
                    </span>

                  </td>


                  <!-- Status -->
                  <td>

                    <span
                      class="status-badge"
                      [ngClass]="
                        user.acc_active
                          ? 'status-badge--active'
                          : 'status-badge--inactive'
                      "
                    >

                      <span class="status-dot"></span>

                      {{
                        user.acc_active
                          ? 'Active'
                          : 'De-Active'
                      }}

                    </span>

                  </td>


                  <!-- Actions -->
                  <td>

                    <div class="table-actions">

                      @if (user.role_id != 2) {

                        <button
                          type="button"
                          class="table-action table-action--status"
                          pTooltip="Activate / Deactivate"
                          tooltipPosition="top"
                          (click)="
                            changeUserStatus(
                              user,
                              user.acc_active
                                ? 'De-Active'
                                : 'Active'
                            )
                          "
                        >
                          <i class="pi pi-sync"></i>
                        </button>

                      }

                      <button
                        type="button"
                        class="table-action table-action--edit"
                        pTooltip="Edit User"
                        tooltipPosition="top"
                        (click)="editUser(user)"
                      >
                        <i class="pi pi-pencil"></i>
                      </button>

                      <button
                        type="button"
                        class="table-action table-action--delete"
                        pTooltip="Delete User"
                        tooltipPosition="top"
                        (click)="deleteUser(user)"
                      >
                        <i class="pi pi-trash"></i>
                      </button>

                    </div>

                  </td>

                </tr>

              }

            }

          </tbody>

        </table>

      </div>


      <!-- =====================================================
           PAGINATION
      ====================================================== -->
      <div class="table-pagination">

        <div class="pagination-summary">

          <span>
            Showing
            <strong>
              {{
                totalRowCount === 0
                  ? 0
                  : (page - 1) * RECORD_LIMIT + 1
              }}
            </strong>

            -

            <strong>
              {{ showingCount }}
            </strong>

            of

            <strong>
              {{ totalRowCount }}
            </strong>
          </span>

        </div>


        <div class="page-size">

          <span>Rows per page</span>

          <select
            [(ngModel)]="RECORD_LIMIT"
            (change)="pageChanged(1)"
          >
            <option [ngValue]="15">15</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="30">30</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>

        </div>


        <div class="pagination-controls">

          <pagination-controls
            [maxSize]="5"
            [responsive]="true"
            [autoHide]="false"
            [directionLinks]="true"
            previousLabel=""
            nextLabel=""
            (pageChange)="pageChanged($event)"
          >
          </pagination-controls>

        </div>

      </div>

    </div>

  </div>
</section>


<!-- =========================================================
     ADD / EDIT USER MODAL
========================================================= -->

<div
  class="custom-modal"
  [ngClass]="{ 'is-active': showPopModal }"
>

  <div
    class="custom-modal-overlay"
    (click)="showPopModal = false"
  ></div>


  <div class="custom-modal-container">

    <!-- Modal Header -->
    <header class="custom-modal-header">

      <div class="modal-heading">

        <div class="modal-heading-icon">
          <i class="pi pi-user-edit"></i>
        </div>

        <div>

          <!-- <span class="modal-eyebrow">
            User Management
          </span> -->

          <h2>
            {{
              editedUserId == null
                ? 'Add New User'
                : 'Edit User'
            }}
          </h2>

          <p>
            {{
              editedUserId == null
                ? 'Create a new user account and add their details.'
                : 'Update user information and account details.'
            }}
          </p>

        </div>

      </div>


      <button
        type="button"
        class="modal-close-btn"
        aria-label="Close"
        (click)="showPopModal = false"
      >
        <i class="pi pi-times"></i>
      </button>

    </header>


    <!-- Modal Body -->
    <div class="custom-modal-body">

      <form
        [formGroup]="newUserForm"
        class="user-form"
      >


        <!-- =================================================
             PROFILE
        ================================================== -->
        <section class="profile-section">

          <div class="profile-card">

            <div class="profile-image-wrapper">

              @if (!updatedUserDetail.user_icon) {

                <img
                  src="../../../assets/images/user-icon.png"
                  alt="User Icon"
                  class="profile-image"
                />

              } @if (updatedUserDetail.user_icon) {

                <img
                  [src]="
                    editedUserId == null
                      ? preProfileUrl + updatedUserDetail.user_icon
                      : profileUrl + updatedUserDetail.user_icon
                  "
                  alt="Profile"
                  class="profile-image"
                />

              }


              @if (!updatedUserDetail.user_icon) {

                <label
                  for="profile"
                  class="profile-upload-btn"
                  title="Upload Profile Picture"
                >

                  <i class="pi pi-camera"></i>

                  <input
                    id="profile"
                    type="file"
                    (change)="onFileChange($event)"
                    accept=".jpg, .jpeg"
                    hidden
                  />

                </label>

              }


              @if (updatedUserDetail.user_icon) {

                <button
                  type="button"
                  class="profile-remove-btn"
                  title="Remove Profile Picture"
                  (click)="deleteUserProfile()"
                >
                  <i class="pi pi-trash"></i>
                </button>

              }

            </div>


            <div class="profile-content">

              <span class="profile-content__label">
                PROFILE PHOTO
              </span>

              <h4>Profile Picture</h4>

              <p>
                Upload a JPG or JPEG image.
              </p>

              @if (updatedUserDetail.user_icon) {

                <span class="profile-status">
                  <i class="pi pi-check-circle"></i>
                  Profile image uploaded
                </span>

              }

            </div>

          </div>

        </section>


        <!-- =================================================
             PERSONAL INFORMATION
        ================================================== -->
        <section class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="pi pi-user"></i>
            </div>

            <div>
              <h3>Personal Information</h3>
              <p>Basic information about the user</p>
            </div>

          </div>


          <div class="input-row">

            <!-- First Name -->
            <div class="input-group">

              <label>
                First Name
                <span>*</span>
              </label>

              <div class="input-wrapper">

                <i class="pi pi-user"></i>

                <input
                  type="text"
                  formControlName="first_name"
                  placeholder="Enter first name"
                  autocomplete="off"
                />

              </div>

              <form-validation
                [control]="newUserForm.controls.first_name"
              >
              </form-validation>

            </div>


            <!-- Last Name -->
            <div class="input-group">

              <label>
                Last Name
                <span>*</span>
              </label>

              <div class="input-wrapper">

                <i class="pi pi-user"></i>

                <input
                  type="text"
                  formControlName="last_name"
                  placeholder="Enter last name"
                  autocomplete="off"
                />

              </div>

              <form-validation
                [control]="newUserForm.controls.last_name"
              >
              </form-validation>

            </div>


            <!-- Role -->
            <div class="input-group">

              <label>
                Role
                <span>*</span>
              </label>

              <div class="input-wrapper select-wrapper">

                <i class="pi pi-shield"></i>

                <select formControlName="user_role">

                  @for (role of roleList; track role) {

                    <option [value]="role.role_id">
                      {{ role.role_name }}
                    </option>

                  }

                </select>

                <i class="pi pi-chevron-down select-arrow"></i>

              </div>

              <form-validation
                [control]="newUserForm.controls.user_role"
              >
              </form-validation>

            </div>

          </div>

        </section>


        <!-- =================================================
             CONTACT INFORMATION
        ================================================== -->
        <section class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="pi pi-address-book"></i>
            </div>

            <div>
              <h3>Contact Information</h3>
              <p>Contact and communication details</p>
            </div>

          </div>


          <div class="input-row">

            <!-- Phone -->
            <div class="input-group">

              <label>
                Contact Number
                <span>*</span>
              </label>

              <div class="input-wrapper">

                <i class="pi pi-phone"></i>

                <input
                  type="text"
                  formControlName="phone_no"
                  placeholder="Enter contact number"
                />

              </div>

              <form-validation
                [control]="newUserForm.controls.phone_no"
              >
              </form-validation>

            </div>


            <!-- Email -->
            <div class="input-group">

              <label>
                Email
                <span>*</span>
              </label>

              <div class="input-wrapper">

                <i class="pi pi-envelope"></i>

                <input
                  type="email"
                  formControlName="email_id"
                  placeholder="Enter email"
                  [readonly]="editedUserId != null"
                />

              </div>

              <form-validation
                [control]="newUserForm.controls.email_id"
              >
              </form-validation>

            </div>


            <!-- Address -->
            <div class="input-group">

              <label>Address</label>

              <div class="input-wrapper">

                <i class="pi pi-map-marker"></i>

                <input
                  type="text"
                  formControlName="user_address"
                  placeholder="Enter address"
                />

              </div>

            </div>

          </div>

        </section>


        <!-- =================================================
             LOCATION
        ================================================== -->
        <section class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="pi pi-map"></i>
            </div>

            <div>
              <h3>Location</h3>
              <p>User location information</p>
            </div>

          </div>


          <div class="input-row">

            <div class="input-group">

              <label>City</label>

              <div class="input-wrapper">

                <i class="pi pi-building"></i>

                <input
                  type="text"
                  formControlName="user_city"
                  placeholder="Enter city"
                />

              </div>

            </div>


            <div class="input-group">

              <label>State</label>

              <div class="input-wrapper">

                <i class="pi pi-map-marker"></i>

                <input
                  type="text"
                  formControlName="user_state"
                  placeholder="Enter state"
                />

              </div>

            </div>


            <div class="input-group">

              <label>ZIP Code</label>

              <div class="input-wrapper">

                <i class="pi pi-hashtag"></i>

                <input
                  type="text"
                  formControlName="user_zip"
                  placeholder="Enter ZIP code"
                />

              </div>

              <form-validation
                [control]="newUserForm.controls.user_zip"
              >
              </form-validation>

            </div>

          </div>

        </section>


        <!-- =================================================
             NOTES
        ================================================== -->
        <section class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="pi pi-file-edit"></i>
            </div>

            <div>
              <h3>Additional Notes</h3>
              <p>Add any additional information about this user</p>
            </div>

          </div>


          <div class="input-group full-width">

            <label>Notes</label>

            <div class="textarea-wrapper">

              <i class="pi pi-align-left"></i>

              <textarea
                rows="4"
                formControlName="user_notes"
                placeholder="Add notes or additional information..."
              ></textarea>

            </div>

          </div>

        </section>

      </form>

    </div>


    <!-- Modal Footer -->
    <footer class="custom-modal-footer">

      <div class="footer-info">

        <i class="pi pi-info-circle"></i>

        <span>
          Fields marked with
          <strong>*</strong>
          are required.
        </span>

      </div>


      <div class="footer-actions">

        <button
          type="button"
          class="cancel-btn"
          (click)="showPopModal = false"
        >
          Cancel
        </button>


        <button
          type="button"
          class="primary-btn"
          [disabled]="
            (newUserForm.valid && !newUserForm.dirty) ||
            newUserForm.invalid
          "
          (click)="updateUserDetail(newUserForm.value)"
        >

          <i
            class="pi"
            [ngClass]="
              editedUserId == null
                ? 'pi-user-plus'
                : 'pi-check'
            "
          >
          </i>

          {{
            editedUserId == null
              ? 'Create User'
              : 'Update User'
          }}

        </button>

      </div>

    </footer>

  </div>
</div>


<!-- Bulk Upload -->
<app-bulk-upload
  [(isOpen)]="open"
  [maxFiles]="30"
  [maxFileSizeMB]="15"
  (filesSelected)="onFilesSelected($event)"
  (close)="open = false"
>
</app-bulk-upload>